/**
 * 获取渠道用户 工具类
 *
 * @author caixinfeng
 * @site https://pay.poa.ai
 * @date 2021/5/8 07:18
 */
const storageKey = 'channelUserId'

const getStorage = function () {
    if (typeof window === 'undefined') {
        return null
    }
    return window.sessionStorage
}

const getChannelUserId = function () {
    const storage = getStorage()
    if (!storage) {
        return ''
    }

    return storage.getItem(storageKey) || ''
}

const setChannelUserId = function (channelUserId) {
    const storage = getStorage()
    if (!storage || !channelUserId) {
        return
    }
    storage.setItem(storageKey, channelUserId)
}

export default {
    getChannelUserId: getChannelUserId,
    setChannelUserId: setChannelUserId
}
